export default "__VITE_ASSET__MrjtNXQl__"